import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		height: "100%",
		width: "100%",
		display: "flex",
		position: "relative",
		...shorthands.overflow("unset"),
	},
	resizeHintRight: {
		left: "-7px"
	}
});
